import { LinkTo } from "shared/constants/linkTo";
import { lazy } from "react";
import { designerPageSsrProps } from "shared/pages/designer/ssr/routesProps";

const DesignerEditView = lazy(() => import("shared/pages/designerEditView"));
const DesignerPage = lazy(() => import("shared/pages/designer"));

const designerRoutes = [
    { path: LinkTo.designer, exact: true, component: () => <DesignerPage whiteTheme ignoreContext contexts={['hsedesign']}/>, ...designerPageSsrProps },
    { path: LinkTo.profile, exact: true, component:() => (<DesignerPage whiteTheme ignoreContext contexts={['hsedesign']}/>) },
    { path: LinkTo.designerEdit, exact: true, isPrivate: true, component: DesignerEditView },
    { path: LinkTo.profileEdit, exact: true, isPrivate: true, component: DesignerEditView },
];

export default designerRoutes;import { LinkTo } from "shared/constants/linkTo";
import { lazy } from "react";
import { designerPageSsrProps } from "shared/pages/designer/ssr/routesProps";

const DesignerEditView = lazy(() => import("shared/pages/designerEditView"));
const DesignerPage = lazy(() => import("shared/pages/designer"));

const designerRoutes = [
    { path: LinkTo.designer, exact: true, component: () => <DesignerPage whiteTheme ignoreContext contexts={['hsedesign']}/>, ...designerPageSsrProps },
    { path: LinkTo.profile, exact: true, component:() => (<DesignerPage whiteTheme ignoreContext contexts={['hsedesign']}/>) },
    { path: LinkTo.designerEdit, exact: true, isPrivate: true, component: DesignerEditView },
    { path: LinkTo.profileEdit, exact: true, isPrivate: true, component: DesignerEditView },
];

export default designerRoutes;